import { useEffect, useState } from 'react';

export const useGetConnectionId = () => {
	const [connectionId, setConnectionId] = useState(
		localStorage.getItem('connectionId') ? localStorage.getItem('connectionId') : null
	);

	useEffect(() => {
		const handleStorageChange = () => {
			const updatedValue = localStorage.getItem('connectionId') || '';

			if (updatedValue !== connectionId) {
				setConnectionId(updatedValue);
			}
		};

		window.addEventListener('connectionId', handleStorageChange);

		return () => {
			window.removeEventListener('connectionId', handleStorageChange);
		};
	}, [connectionId]);

	return {
		connectionId,
	};
};
